import OffersHistory from "components/offersHistory/offersHistoryPanel";

export default () => {
  return (
  <div>
    <OffersHistory></OffersHistory>
  </div>
  );
};
